export const LiveIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M9.5 2C4.80558 2 1 5.80558 1 10.5C1 15.1944 4.80558 19 9.5 19C14.1944 19 18 15.1944 18 10.5C17.995 5.80768 14.1924 2.00502 9.5 2ZM13.0797 10.7708C13.0208 10.8889 12.9252 10.9846 12.8071 11.0434V11.0464L7.94997 13.475C7.65 13.6249 7.28536 13.5033 7.13545 13.2033C7.09283 13.118 7.07088 13.0239 7.07141 12.9286V8.07145C7.07127 7.73612 7.34296 7.46419 7.67828 7.46401C7.77259 7.46397 7.86562 7.48589 7.94997 7.52804L12.8071 9.95663C13.1072 10.1062 13.2293 10.4707 13.0797 10.7708Z"
      fill="white"
    />
  </svg>
);
